import { Badge } from "../../components/ui";
import { t } from "../../i18n/i18n";
import { formatPct, type ZoneChip } from "./zoneState";

/** Pastille durable de la préparation d'une zone libre (docs/14 §2.7.5), commune à la barre latérale et aux cartes
 *  de dossier de l'accueil : en file (rang), en préparation (pourcentage), en échec, annulé (pastilles accordées au terrain). */

export type ZoneChipTone = "run" | "danger" | "neutral";

/** Ton, libellé court et infobulle d'une pastille. */
export function zoneChipText(chip: NonNullable<ZoneChip>): { tone: ZoneChipTone; label: string; title: string } {
  switch (chip.kind) {
    case "preparing":
      return { tone: "run", label: t("{pct} %", { pct: formatPct(chip.pct) }), title: t("Terrain en préparation : {pct} %", { pct: formatPct(chip.pct) }) };
    case "queued":
      return {
        tone: "run",
        label: t("En file"),
        title: chip.position ? t("Terrain en file de préparation (rang {n})", { n: chip.position }) : t("Terrain en file de préparation"),
      };
    case "failed":
      return { tone: "danger", label: t("Échec"), title: t("Préparation du terrain en échec") };
    default:
      return { tone: "neutral", label: t("Annulé"), title: t("Préparation du terrain annulée") };
  }
}

export function ZoneChipBadge({ chip, className }: { chip: ZoneChip; className?: string }) {
  if (!chip) return null;
  const { tone, label, title } = zoneChipText(chip);
  return (
    <Badge size="sm" dot tone={tone} title={title} className={className}>
      {label}
    </Badge>
  );
}
